import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrencyBRLProxyPipe } from '../pipes/currency.pipe';
import { FieldControlErrorComponent } from './field-control-error.component';

@NgModule({
  declarations: [FieldControlErrorComponent],
  imports: [CommonModule],
  exports: [FieldControlErrorComponent],
  providers: [CurrencyBRLProxyPipe],
})
export class FieldControlErrorModule {}
